"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FudaoUserStatus;
(function (FudaoUserStatus) {
    FudaoUserStatus["None"] = "None";
    FudaoUserStatus["Offline"] = "Offline";
    FudaoUserStatus["Online"] = "Online";
    FudaoUserStatus["Busy"] = "Busy";
})(FudaoUserStatus = exports.FudaoUserStatus || (exports.FudaoUserStatus = {}));
class FudaoUser {
    constructor(fudaoUser) {
        this.Id = "";
        this.Name = "";
        this.Roles = [];
        this.Suspension = false;
        this.Status = FudaoUserStatus.None;
        this.Avatar = "";
        this.DisplayName = "";
        this.FavoriteTeachers = [];
        this.HighestEducation = "";
        this.Rating = 0;
        this.YearOfService = 0;
        this.Subjects = [];
        this.Experience = "";
        this.SelfIntro = "";
        this.SchoolSystemIds = []; //學制，老師與學生共用
        this.StudentGrade = 0;
        this.StudentGender = "";
        this.StudentPoint = 0;
        if (fudaoUser) {
            this.Id = fudaoUser.Id || this.Id;
            this.Name = fudaoUser.Name || this.Name;
            this.Roles = fudaoUser.Roles ? fudaoUser.Roles.slice() : this.Roles;
            this.Suspension = fudaoUser.Suspension || this.Suspension;
            this.Status = fudaoUser.Status || this.Status;
            this.Avatar = fudaoUser.Avatar || this.Avatar;
            this.DisplayName = fudaoUser.DisplayName || this.DisplayName;
            this.FavoriteTeachers = fudaoUser.FavoriteTeachers || this.FavoriteTeachers;
            this.HighestEducation = fudaoUser.HighestEducation || this.HighestEducation;
            this.Rating = fudaoUser.Rating || this.Rating;
            this.YearOfService = fudaoUser.YearOfService || this.YearOfService;
            this.Subjects = fudaoUser.Subjects || this.Subjects;
            this.Experience = fudaoUser.Experience || this.Experience;
            this.SelfIntro = fudaoUser.SelfIntro || this.SelfIntro;
            this.SchoolSystemIds = fudaoUser.SchoolSystemIds ? fudaoUser.SchoolSystemIds.slice() : this.SchoolSystemIds;
            this.StudentGrade = fudaoUser.StudentGrade || this.StudentGrade;
            this.StudentGender = fudaoUser.StudentGender || this.StudentGender;
            this.StudentPoint = fudaoUser.StudentPoint || this.StudentPoint;
        }
    }
    Is(t2) { return (this.Id === t2.Id) && (this.Name === t2.Name); }
    get IsTeacher() { return this.Roles.findIndex(r => r === FudaoUser.ROLE_TEACHER_ID) !== -1; }
    get IsStudent() { return this.Roles.findIndex(r => r === FudaoUser.ROLE_STUDENT_ID) !== -1; }
    static CreateTeacher(id, name) {
        const t = new FudaoUser({ Id: id, Name: name });
        t.Roles.push(FudaoUser.ROLE_TEACHER_ID);
        return t;
    }
    static CreateStudent(id, name) {
        const s = new FudaoUser({ Id: id, Name: name });
        s.Roles.push(FudaoUser.ROLE_STUDENT_ID);
        return s;
    }
}
FudaoUser.ROLE_TEACHER_ID = "59648962ca544543e1ba90e1";
FudaoUser.ROLE_STUDENT_ID = "59648973ca544543e1ba90e2";
FudaoUser.INVALID_FUDAO_USER = new FudaoUser();
exports.FudaoUser = FudaoUser;
//# sourceMappingURL=FudaoUser.js.map